export const LABEL_PRINT_TYPE = {
  PRODUCT: 'PRODUCT',
  SIMPLE: 'SIMPLE',
  PRODUCT_TAG: 'PRODUCT_TAG',
  PRODUCT_TAG_ORIGIN: 'PRODUCT_TAG_ORIGIN',
  OUTERBOX: 'OUTERBOX',
  RACK: 'RACK',
  TOTE: 'TOTE',
  CART: 'CART',
  PACKING_MATERIAL: 'PACKING_MATERIAL',
  CARTON: 'CARTON',
  BOXLABEL: 'BOXLABEL',
  TRACKING: 'TRACKING',
  TRACKING_BULK: 'TRACKING_BULK',
  TEMPLATE: 'TEMPLATE',
};

const FLAT_FIELD = {
  [LABEL_PRINT_TYPE.PRODUCT]: 'product',
  [LABEL_PRINT_TYPE.SIMPLE]: 'productSimple',
  [LABEL_PRINT_TYPE.PRODUCT_TAG]: 'productTag',
  [LABEL_PRINT_TYPE.PRODUCT_TAG_ORIGIN]: 'productTagOrigin',
  [LABEL_PRINT_TYPE.OUTERBOX]: 'outerBox',
  [LABEL_PRINT_TYPE.PACKING_MATERIAL]: 'packingMaterial',
  [LABEL_PRINT_TYPE.CARTON]: 'carton',
};

const CONTAINER = {
  [LABEL_PRINT_TYPE.RACK]: {
    field: 'rack',
    header: ['locationId', 'rackNumber'],
    item: 'rackSlotNumber',
  },
  [LABEL_PRINT_TYPE.TOTE]: {
    field: 'tote',
    header: ['locationId', 'toteNumber'],
    item: 'toteItemNumber',
  },
  [LABEL_PRINT_TYPE.CART]: {
    field: 'cart',
    header: ['locationId', 'cartNumber'],
    item: 'cartItemNumber',
  },
};

const groupBy = (rows, keyOf) =>
  rows.reduce((acc, row) => {
    const key = keyOf(row);
    (acc[key] = acc[key] ?? []).push(row);
    return acc;
  }, {});

export function buildLabelPrintRequests({ printType, rows }) {
  const container = CONTAINER[printType];

  if (container) {
    const groups = groupBy(rows, (row) =>
      container.header.map((key) => row.printPayload?.[key]).join('|'),
    );
    return Object.values(groups).map((group) => {
      const header = Object.fromEntries(
        container.header.map((key) => [key, group[0].printPayload?.[key]]),
      );
      return {
        printType,
        [container.field]: {
          ...header,
          items: group[0].isWholeContainer
            ? []
            : group.map((row) => ({
                [container.item]: row.printPayload?.[container.item],
                quantity: row.quantity,
              })),
        },
      };
    });
  }

  const field = FLAT_FIELD[printType];
  if (field) {
    return [
      {
        printType,
        [field]: {
          items: rows.map((row) => ({ ...row.printPayload, quantity: row.quantity })),
        },
      },
    ];
  }

  if (printType === LABEL_PRINT_TYPE.BOXLABEL) {
    return rows.map((row) => ({
      printType,
      boxLabel: {
        bulkShipmentId: row.printPayload?.bulkShipmentId,
        boxSequences: row.boxSequences ?? null,
      },
    }));
  }

  if (printType === LABEL_PRINT_TYPE.TRACKING_BULK) {
    return rows.map((row) => ({
      printType,
      trackingBulk: {
        bulkShipmentId: row.printPayload?.bulkShipmentId,
        boxSequences: row.boxSequences ?? null,
      },
    }));
  }

  if (printType === LABEL_PRINT_TYPE.TRACKING) {
    return rows.map((row) => ({
      printType,
      tracking: { orderShipmentId: row.printPayload?.orderShipmentId },
    }));
  }

  return [];
}
